import SelectTagInput from '@/components/SelectTagInput'
import { FilterSection } from './FilterSection'
import { LucideIcon } from 'lucide-react'

interface FilterSectionTagInputProps {
  icon: LucideIcon
  label: string
  value: string[]
  onChange: (ids: string[]) => void
  items: { id: string; name: string }[]
  loading: boolean
  placeholder?: string
}

export function FilterSectionTagInput({
  icon,
  label,
  value,
  onChange,
  items,
  loading,
  placeholder = 'Procure por ID e Selecione',
}: FilterSectionTagInputProps) {
  return (
    <FilterSection icon={icon} label={label}>
      <SelectTagInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        showSearchIcon
        hideButton
        items={items}
        loading={loading}
      />
    </FilterSection>
  )
}
